module.exports = __webpack_public_path__ + "static/media/smart-goals@3x.ccf732c2.png";